/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CompanyTaxSetupListDto } from '../models/PagedResultDto_CompanyTaxSetupListDto';
import type { PagedResultDto_GetTaxItemDto } from '../models/PagedResultDto_GetTaxItemDto';
import type { Wealthlane_TaxService_Dtos_Response_ResponseDto } from '../models/Wealthlane_TaxService_Dtos_Response_ResponseDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_CreateTaxItemOverrideDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_CreateTaxItemOverrideDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_CreateTaxItemRequestDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_CreateTaxItemRequestDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_GetTaxBracketDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_GetTaxBracketDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_IncomeYTDTypeListDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_IncomeYTDTypeListDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemIdsListDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemIdsListDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_UpdateTaxBracketDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_UpdateTaxBracketDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_UpdateTaxItemDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_UpdateTaxItemDto';
import type { Wealthlane_TaxService_Dtos_TaxItemDto_VendorTaxItemIdsListDto } from '../models/Wealthlane_TaxService_Dtos_TaxItemDto_VendorTaxItemIdsListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaxItemService {

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemTaxItem(
requestBody?: Wealthlane_TaxService_Dtos_TaxItemDto_CreateTaxItemRequestDto,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item/tax-item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiTaxApiAppTaxItemTaxItem(
requestBody?: Wealthlane_TaxService_Dtos_TaxItemDto_UpdateTaxItemDto,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tax/api/app/tax-item/tax-item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemTaxItemOverride(
requestBody?: Wealthlane_TaxService_Dtos_TaxItemDto_CreateTaxItemOverrideDto,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item/tax-item-override',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxItemId 
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemTaxItemById(
taxItemId: string,
): CancelablePromise<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/tax-item-by-id/{TaxItemId}',
            path: {
                'TaxItemId': taxItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxPeriodId 
     * @param taxApprovalStatusId 
     * @param incomeYtdTypeId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_GetTaxItemDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemTaxItemList(
taxPeriodId?: string,
taxApprovalStatusId?: number,
incomeYtdTypeId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_GetTaxItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/tax-item-list',
            query: {
                'TaxPeriodId': taxPeriodId,
                'TaxApprovalStatusId': taxApprovalStatusId,
                'IncomeYTDTypeId': incomeYtdTypeId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemIdsListDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemApprovedTaxItemIdsList(): CancelablePromise<Array<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemIdsListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/approved-tax-item-ids-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxPeriodId 
     * @param taxApprovalStatusId 
     * @param incomeYtdTypeId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_GetTaxItemDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemPagedTaxItemListForApproval(
taxPeriodId?: string,
taxApprovalStatusId?: number,
incomeYtdTypeId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_GetTaxItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/paged-tax-item-list-for-approval',
            query: {
                'TaxPeriodId': taxPeriodId,
                'TaxApprovalStatusId': taxApprovalStatusId,
                'IncomeYTDTypeId': incomeYtdTypeId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxItemId 
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_GetTaxBracketDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemTaxBracketListById(
taxItemId: string,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_TaxItemDto_GetTaxBracketDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/tax-bracket-list-by-id/{taxItemId}',
            path: {
                'taxItemId': taxItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiTaxApiAppTaxItemTaxBracketListById(
requestBody?: Wealthlane_TaxService_Dtos_TaxItemDto_UpdateTaxBracketDto,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tax/api/app/tax-item/tax-bracket-list-by-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemSendForApproval(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item/send-for-approval',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxItemId 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiTaxApiAppTaxItemTaxItem(
taxItemId: string,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tax/api/app/tax-item/tax-item/{taxItemId}',
            path: {
                'taxItemId': taxItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param remarks 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemTaxItemDeactivateSendForApproval(
remarks?: string,
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item/tax-item-deactivate-send-for-approval',
            query: {
                'Remarks': remarks,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param thisYearTax 
     * @param nextYearTax 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CompanyTaxSetupListDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemCompanyTaxSetupList(
thisYearTax?: boolean,
nextYearTax?: boolean,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CompanyTaxSetupListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/company-tax-setup-list',
            query: {
                'ThisYearTax': thisYearTax,
                'NextYearTax': nextYearTax,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vendorTaxPeriodId 
     * @param jurisdictionId 
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_VendorTaxItemIdsListDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemVendorTaxListForCompany(
vendorTaxPeriodId?: string,
jurisdictionId?: string,
): CancelablePromise<Array<Wealthlane_TaxService_Dtos_TaxItemDto_VendorTaxItemIdsListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/vendor-tax-list-for-company',
            query: {
                'VendorTaxPeriodId': vendorTaxPeriodId,
                'JurisdictionId': jurisdictionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxItemId 
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemVendorTaxItemByIdForCompany(
taxItemId: string,
): CancelablePromise<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/vendor-tax-item-by-id-for-company/{TaxItemId}',
            path: {
                'TaxItemId': taxItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemVendorTaxCopyByCompany(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item/vendor-tax-copy-by-company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemIdsListDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemVendorTaxPeriodListForCompany(): CancelablePromise<Array<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemIdsListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/vendor-tax-period-list-for-company',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_TaxService_Dtos_TaxItemDto_IncomeYTDTypeListDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppTaxItemIncomeYTdTypes(): CancelablePromise<Array<Wealthlane_TaxService_Dtos_TaxItemDto_IncomeYTDTypeListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/tax-item/income-yTDTypes',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param remarks 
     * @param requestBody 
     * @returns Wealthlane_TaxService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiTaxApiAppTaxItemTaxItemReactivateSendForApproval(
remarks?: string,
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_TaxService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tax/api/app/tax-item/tax-item-reactivate-send-for-approval',
            query: {
                'Remarks': remarks,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
